import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroCover from "@/pages/home/components/HeroCover";
import DeepDiveSection from "@/pages/home/components/DeepDiveSection";
import CollectionIndex from "@/pages/home/components/CollectionIndex";
import ArchiveGrid from "@/pages/home/components/ArchiveGrid";
import TimelineSection from "@/pages/home/components/TimelineSection";
import ReactionsSection from "@/pages/home/components/ReactionsSection";
import RankingSection from "@/pages/home/components/RankingSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroCover />
        <DeepDiveSection />
        <CollectionIndex />
        <ArchiveGrid />
        <TimelineSection />
        <ReactionsSection />
        <RankingSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}